<template>
  <div class="user_container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <div class="goback_search">
        <el-input
          v-model="searchValue"
          placeholder="请输入..."
          @input="search"
        ></el-input>
        <i class="el-icon-search"></i>
      </div>
    </div>
    <div class="content">
      <van-list
        v-if="moreList.length > 0"
        v-model="loadingOne"
        :finished="finishedOne"
        finished-text="没有更多了"
        @load="onLoadOne"
        loading-text="加载中，下拉查看更多"
        offset="10"
        :immediate-check="false"
      >
        <div
          class="list_con"
          v-for="(item, index) in moreList"
          :key="index"
        >
          <div class="list_index">
            <div>{{ index +1 }}</div>
            <div
              class="circle"
              v-if="$store.state.userInfo.username == item.userName"
            ></div>
          </div>
          <div class="list_item">
            <div class="item_left">
              <img class="avatar" :src="item.headpic" alt="" />
              <div class="info_con">
                <div class="info_top">{{item.empName}}</div>
                <div class="info_bottom">{{item.departmentName}}</div>
              </div>
            </div>
            <div class="list_num">{{item.enterTime}}</div>
          </div>
        </div>
      </van-list>
      <div class="kong_con" v-else>
        <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
        <div class="kong_title kong_title1">没有更多报名人员</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/medal";
import apis from "@/apis/publicWelfare";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      searchValue: "",
      moreList: [],
      imgUrl: "",
      loadingOne: false,
      finishedOne: false,
      total: 0,
      page: 1,
      pageSize: 20,
      id:''
    };
  },
  created() {},
  mounted() {
    this.imgUrl = api.imgUrl;
    this.id = this.$route.query.id
    // this.id = id
    this.onLoadOne();
  },
  methods: {
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },
    // 搜索
    search() {
      this.queryMoretList();
    },

    onLoadOne() {
      this.queryMoretList();
    },
    //获取更多报名人员列表
    queryMoretList() {
      apis
        .signInStatistics({
          activityId:this.id,
          empName: this.searchValue,
          type: 2
        })
        .then(res => {
          if (res.code == 200) {
            this.moreList = res.data;
            this.moreList.forEach(item => {
              if(item.enterTime){
                item.enterTime = moment(item.enterTime).format("YYYY-MM-DD HH:mm");
              }
            })
            // this.total = res.data.total;
            // this.finishedOne = false;
            // if (this.page === 1) {
            //   this.moreList = res.data.list;
            // } else {
            //   this.moreList = this.moreList.concat(res.data.list);
            // }
            // if (this.moreList.length < this.total) {
            //   this.page = this.page + 1;
            // } else {
            //   this.finishedOne = true;
            // }

            // this.loadingOne = false;
            // this.moreList.map(item => {
            //   item.create_time = moment(item.create_time).format("YYYY-MM-DD");
            // });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .detail_title_info {
    width: 100%;
    height: 100%;
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 20px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  .pick {
    width: 48%;
    height: 80px;
    border-radius: 80px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    margin-bottom: 15px;
    .newDate {
      flex: 1;
      // height: 40px;
    }
    div {
      color: #969b9e;
      font-size: 30px;
    }
    i {
      color: #969b9e;
    }
  }
}

.content {
  overflow: auto;
  height: calc(100vh - 195px);
  margin-top: 30px;
  background-color: #fff;
  border-radius: 30px;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .list_con {
    display: flex;
    align-items: center;
    margin: 36px 0;
    .list_index {
      width: 60px;
      color: #21242d;
      font-size: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      margin-left: 20px;
      .circle {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #ff5c5c;
        margin-top: 5px;
      }
    }
    .list_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      padding: 8px 12px;
      border-radius: 80px;
      .item_left {
        display: flex;
        align-items: center;
      }
      .avatar {
        width: 86px;
        height: 86px;
        border-radius: 50%;
        margin-right: 30px;
      }
      .info_con {
        .info_top {
          font-size: 26px;
          color: #191b20;
          margin-bottom: 10px;
        }
        .info_bottom {
          font-size: 22px;
          color: #666666;
        }
      }
      .list_num {
        font-size: 26px;
        margin-right: 30px;
        color: #121826;
      }
    }
  }
  .kong_con {
    width: 100%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    justify-content: center;
    .kong_img {
      width: 450px;
      height: 450px;
    }
    .kong_title1 {
      margin-top: 30px !important;
    }
    .kong_title {
      color: #999999;
      font-size: 26px;
      margin-top: 10px;
    }
  }
}
</style>
